// extracted by mini-css-extract-plugin
export default {"line":"styles_line__BmrIV","line1":"styles_line1__wP0yY","line2":"styles_line2__wtcCs","line3":"styles_line3__Or6YL"};